$(document).ready(function () {

$(document).on('click', 'a[href="#quiz"], a[href="#quiz"] *', function (e) {
  e.preventDefault();
  const newUrl = window.location.origin + window.location.pathname + '#quiz';
  window.location.href = newUrl;
});

if($('.right-phones-wrapper').length > 0){
  featuredSwiper = new Swiper('.right-phones-wrapper.swiper', {
    slidesPerView: 'auto',
    spaceBetween: 20,
  });
}

if($('.swiper-compare.swiper').length > 0){
    compareSwiper = new Swiper('.swiper-compare.swiper', {
      slidesPerView: 'auto',
      loop: false,
      speed: 500,
      allowTouchMove: window.innerWidth <= 749,
      navigation: {
          nextEl: '.swiper-compare-section .swiper-button-next',
          prevEl: '.swiper-compare-section .swiper-button-prev',
      },
    });
    
    $(".twentytwenty-container").twentytwenty();

    const swiperEl = document.querySelector(".swiper-compare");

    function handleBlockSwipe(e) {
      if (window.innerWidth > 749) {
        compareSwiper.allowTouchMove = false;
        return;
      }
      // Disable only if user touches inside compare_content
      compareSwiper.allowTouchMove = !e.target.closest(".compare_content");
    }

    swiperEl.addEventListener("touchstart", handleBlockSwipe, { passive: true });
    swiperEl.addEventListener("pointerdown", handleBlockSwipe);
    swiperEl.addEventListener("mousedown", handleBlockSwipe);

    // Update on resize
    window.addEventListener("resize", () => {
      compareSwiper.allowTouchMove = window.innerWidth <= 749;
    });

}

if($('.products-slide.swiper').length > 0){
    featuredSwiper = new Swiper('.products-slide.swiper', {
      slidesPerView: 'auto',
      spaceBetween: 25,
      scrollbar: {
        el: '.products-slide.swiper .swiper-scrollbar',
        hide: false,
      },
      navigation: {
        nextEl: '.products-slide.swiper .slider-button--next',
        prevEl: '.products-slide.swiper .slider-button--prev',
    },
    });
  }

var $trigger = $(".product__info-wrapper reviewsio-product-ratings");
var $reviews = $("#reviews");

function activateAndScroll() {
  if ($reviews.length) {
    $reviews.addClass("active");
    $("html, body").animate(
      { scrollTop: $reviews.offset().top },
      600 // duration in ms
    );
  }
}

// Click handler
$trigger.on("click", function (e) {
  e.preventDefault();
  activateAndScroll();

  if (window.location.hash !== "#reviews") {
    history.pushState(null, "", "#reviews");
  }
});

// On page load with #reviews in URL
if (window.location.hash === "#reviews") {
  setTimeout(activateAndScroll, 200);
}

document.addEventListener('click', function(e) {
    const target = e.target.closest('[href="#quiz"], [data-href="#quiz"]');

    if (target) {

        e.preventDefault();
        e.stopPropagation();

        const newUrl = window.location.origin + window.location.pathname + '#quiz';
        window.location.href = newUrl;

        setTimeout(() => {
          console.log(newUrl);
          window.location.reload();
        }, 200);
    }
}, true);

let mobileSwiper;
let featuredBlogSwiper;
let handleBlogSwiper;

function initMobileSwiper() {
  const shouldInit = window.innerWidth <= 767;
  const container = document.querySelector('.kapua-slider-wrapper');

  if (shouldInit && !mobileSwiper && container) {
    mobileSwiper = new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 20,
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
      },
    });
  }

  if (!shouldInit && mobileSwiper) {
    mobileSwiper.destroy(true, true);
    mobileSwiper = null;
  }


  const shouldInitBlog = window.innerWidth <= 989;

  const containerFeatured = document.querySelector('.featured-blog-wrapper');

  if (shouldInitBlog && !featuredBlogSwiper && containerFeatured) {
    
/*     featuredBlogSwiper = new Swiper(containerFeatured, {
      slidesPerView: 'auto',
      spaceBetween: 30,
      loop: true,
      centeredSlides: false,
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
      },
    }); */

  featuredBlogSwiper = new Swiper(containerFeatured, {
    slidesPerView: 'auto',
    spaceBetween: 30,
    loop: true,
    centeredSlides: false,
    roundLengths: true,

    scrollbar: {
      el: '.swiper-scrollbar',
      hide: false,
      draggable: true,
    },

    resistanceRatio: 0.85,
    preventInteractionOnTransition: true,

    on: {
      slideChangeTransitionEnd() {
        this.slideToLoop(this.realIndex, 0, false);
      },

      touchEnd() {
        requestAnimationFrame(() => {
          this.slideToLoop(this.realIndex, 0, false);
        });
      },

      resize() {
        this.slideToLoop(this.realIndex, 0, false);
      },

      setTranslate(swiper) {
        const scrollbar = swiper.scrollbar;
        if (scrollbar && scrollbar.dragEl) {
          const totalSlides = swiper.slides.length - swiper.loopedSlides * 2;
          const realIndex = swiper.realIndex;
          const progress = realIndex / (totalSlides - 1);
          const trackSize = scrollbar.trackSize - scrollbar.dragSize;
          const newPos = trackSize * progress;
          scrollbar.dragEl.style.transform = `translate3d(${newPos}px, 0, 0)`;
        }
      },
    },
  });
  }

  if (!shouldInitBlog && featuredBlogSwiper) {
    console.log('destroy');
    featuredBlogSwiper.destroy(true, true);
    featuredBlogSwiper = null;
  }

  const containerHandle = document.querySelector('.blog-links');

  if (shouldInitBlog && !handleBlogSwiper && containerHandle) {
    handleBlogSwiper = new Swiper(containerHandle, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

  if (!shouldInitBlog && handleBlogSwiper) {
    handleBlogSwiper.destroy(true, true);
    handleBlogSwiper = null;
  }

}

window.addEventListener('load', initMobileSwiper);
window.addEventListener('resize', initMobileSwiper);


  if(jQuery('.image-repeater-section').length > 0){
    imageSwiper = new Swiper('.image-repeater-section', {
      slidesPerView: 'auto',
      spaceBetween: 20,
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    });

    // Detect if mobile (simple check)
    function isMobile() {
      return window.innerWidth <= 767;
    }

    // Get popup elements
    const popup = document.getElementById('popup');
    const popupContent = document.getElementById('popup-content');
    const popupClose = document.getElementById('popup-close');

    popupClose.addEventListener('click', () => {
      popup.classList.remove('show');
    });

    popup.addEventListener('click', (e) => {
      if (e.target === popup) {
        popup.classList.remove('show');
      }
    });

    // Add click listener to slides
    imageSwiper.slides.forEach(slide => {
      slide.addEventListener('click', () => {
        if (!isMobile()) return; // only trigger on mobile

        const clickedIndex = Array.from(imageSwiper.slides).indexOf(slide);
        /* if (clickedIndex === imageSwiper.activeIndex) { */
          const reviewContent = slide.querySelector('.review-content');
          if (reviewContent) {
            popupContent.innerHTML = reviewContent.innerHTML;
            popup.classList.add('show');
          } else {
            popup.classList.remove('show');
          }
        /* } */
      });
    });
  }

      if(jQuery('.reviews-swiper').length > 0){
    reviewSwiper = new Swiper('.reviews-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      effect: "fade",
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
    });
  }

  
    if(jQuery('.featured-collection.swiper').length > 0){
    featuredSwiper = new Swiper('.featured-collection.swiper', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      scrollbar: {
        el: '.featured-collection.swiper .swiper-scrollbar',
        hide: false,
      },
      navigation: {
        nextEl: '.featured-collection.swiper .slider-button--next',
        prevEl: '.featured-collection.swiper .slider-button--prev',
    },
    });
  }

  if(jQuery('.image-col.swiper').length > 0){
    featuredSwiper = new Swiper('.image-col.swiper', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      scrollbar: {
        el: '.image-col.swiper .swiper-scrollbar',
        hide: false,
      },
      navigation: {
        nextEl: '.image-col.swiper .slider-button--next',
        prevEl: '.image-col.swiper .slider-button--prev',
    },
    });
  }

  if(jQuery('.product-repeater-section .product-repeater').length > 0){
      jQuery('.product-repeater').slick({
		    arrows: true,
		    dots: false,
		    padding: '10px',
        slidesToShow: 3,
		    slidesToScroll: 1,
		    autoplay:false,
		    autoplaySpeed: 4000,
		    speed:1000,
		    centerMode: false,
		    infinite: true,
		    pauseOnHover:false,
		    responsive: [
		    {
		      breakpoint: 1250,
		        settings: {
		          slidesToShow: 2,
		          slidesToScroll: 1,	
		        }
		    },
		    {
		      breakpoint: 1024,
		      settings: {
		        slidesToShow: 1,
		        slidesToScroll: 1,
		      }
		    }
		    ]
      });
      
       jQuery('.product-repeater').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		    let slidesLength = slick.$slides.length - 1,
		    isCurrentFirstOrLast = currentSlide === 0 || currentSlide === slidesLength,
		    isNextFirstOrLast = nextSlide === 0 || nextSlide === slidesLength;
            
		    if (isCurrentFirstOrLast && isNextFirstOrLast){
		    let nextClone = jQuery(event.currentTarget).find('.slick-cloned.slick-active');
		    setTimeout(function(){
		    nextClone.addClass('slick-active');
		    }, 100)
		    }
       });
  }


    const observer = new MutationObserver(function () {
      $('.ruk_rating_snippet').each(function () {
        const $div = $(this);

        // Skip if already processed
        if ($div.next('.rating-meta-wrapper').length) return;

        const ratingText = $div.attr('title') || $div.attr('aria-label');
        // const match = ratingText?.match(/^([\d.]+)\s+Stars\s*-\s*(\d+)\s+Reviews$/);
        const match = ratingText?.match(/^([\d.]+)\s+Stars\s*-\s*(\d+)(?:\s+Reviews)?$/);
        //console.log(match);
        if (match) {
          const [, rawRating, count] = match;
          const rating = Math.round(parseFloat(rawRating) * 10) / 10;

          const $wrapper = $('<div>', { class: 'rating-meta-wrapper' });

          const $starDiv = $('<div>', {
            class: 'star-value',
            html: `${rating}/5 <i aria-hidden="true" class="ruk-icon-percentage-star--100"></i>`
          });

          const $reviewDiv = $('<div>', {
            class: 'review-count',
            text: `${count} Bewertungen`
          });

          $wrapper.append($starDiv, $reviewDiv);
          $div.after($wrapper);
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

  const navLinks = document.querySelectorAll(
  ".account-header-nav a, .account-nav-item a, #account-infor a"
);
const sections = document.querySelectorAll(".main-content > div");

function showSection(id) {
  sections.forEach(sec => sec.style.display = "none");
  const target = document.querySelector(id);
  if (target) target.style.display = "flex";

  navLinks.forEach(link => {
    const href = link.getAttribute("href");
    if (href === id) {
      link.classList.add("active");
    } else {
      link.classList.remove("active");
    }
  });
}

if (sections.length > 0) {
  showSection("#" + sections[0].id);
}

navLinks.forEach(link => {
  link.addEventListener("click", function (e) {
    const targetId = this.getAttribute("href");
    if (targetId && targetId.startsWith("#")) {
      e.preventDefault();
      showSection(targetId);
      history.replaceState(null, "", targetId);

     if (targetId === "#account-wishlist") {
        const wishlistIcon = document.querySelector("a.wishlist-hero-header-icon");
        if (wishlistIcon){
            wishlistIcon.click();
        } 
      }
    }
  });
});

// Handle direct link with hash (e.g. /account#account-addresses)
const hash = window.location.hash;
if (hash && document.querySelector(hash)) {
  showSection(hash);

  if (hash === "#account-wishlist") {
    const wishlistIcon = document.querySelector("a.wishlist-hero-header-icon");
    if (wishlistIcon){
      const waitForWishlist = setInterval(() => {
      const list = document.querySelector(".wishlisthero-customer-view-listing");
      if (list) {
        clearInterval(waitForWishlist);
      }else{
        wishlistIcon.click();
      }
      }, 300);
    }
  }
}

 const videos = document.querySelectorAll('deferred-media video');

  videos.forEach(video => {
    // Hide native controls initially
    video.removeAttribute('controls');

    // Show on hover (desktop)
    video.addEventListener('mouseenter', () => {
      video.setAttribute('controls', true);
    });

    video.addEventListener('mouseleave', () => {
      video.removeAttribute('controls');
    });

    // Toggle on tap (mobile)
    let lastTap = 0;
    video.addEventListener('click', () => {
      const now = new Date().getTime();
      const tapLength = now - lastTap;

      if (tapLength < 500 && tapLength > 0) {
        // Double-tap: remove controls
        video.removeAttribute('controls');
      } else {
        video.setAttribute('controls', true);
      }

      lastTap = now;
    });
  });

});


document.addEventListener('DOMContentLoaded', () => {
  const checkReady = setInterval(() => {
    const observerTarget = document.querySelector('.wishlist-hero-items-count:not(.wishlist-hero-header-icon .wishlist-hero-items-count)');
    const secondCounter = document.querySelector('.wishlist-hero-header-icon.clone .wishlist-hero-items-count');

    if (!observerTarget || !secondCounter) return;

    clearInterval(checkReady);

    const syncCount = () => {
      let count = observerTarget.textContent.trim();
      count = count.replace(/[()]/g, ''); // Strip parentheses
      secondCounter.textContent = count;
      secondCounter.style.display = count === "0" || !count ? "none" : "inline-block";
    };

    const observer = new MutationObserver(syncCount);
    observer.observe(observerTarget, {
      characterData: true,
      childList: true,
      subtree: true
    });

    syncCount();
  }, 100);

  document.addEventListener('click', function (event) {
    const link = event.target.closest('.Meteor-Drawer[data-active="true"] .Meteor-Drawer__Item a');
    if (link) {
      const href = link.getAttribute('href')?.trim().toLowerCase();
      if (href === '#quiz') {
        event.preventDefault();
        window.location.href = window.location.pathname + window.location.search + '#quiz';
        window.location.reload(true);
      }
    }
  });


  const modal = document.getElementById("quickAddModal");
  const closeBtn = modal.querySelector(".quick-add-modal__toggle");


  // Close on button click
  closeBtn.addEventListener("click", () => {
  modal.style.display = "none";
  });


  // Close on outside click
  window.addEventListener("click", (event) => {
  if (event.target === modal) {
  modal.style.display = "none";
  }
  });
});


  jQuery(document).ready(function () {
    const $reveals = jQuery('#MainContent>*');

    
    function triggerReveal() {
      const windowHeight = $(window).height();
      const triggerLine = $(window).scrollTop() + windowHeight * 0.7;

      $reveals.each(function () {
        const $el = $(this);
        const elementTop = $el.offset().top;

        if (!$el.hasClass('reveal--active') && elementTop < triggerLine) {
          $el.addClass('reveal--active');
        }
      });
    }

    $(window).on('scroll resize', triggerReveal);
    triggerReveal();
  });

function updateHyphens() {
  document.querySelectorAll('span.word').forEach(wordGroup => {
    const spans = Array.from(wordGroup.querySelectorAll(':scope > span'));
    spans.forEach(s => s.classList.remove('break'));
    if (spans.length === 0) return;

    let prevTop = spans[0].getBoundingClientRect().top;
    for (let i = 1; i < spans.length; i++) {
      const currentTop = spans[i].getBoundingClientRect().top;
      if (currentTop > prevTop + 0.5) {
        spans[i - 1].classList.add('break');
      }
      prevTop = currentTop;
    }
  });
}

window.addEventListener('DOMContentLoaded', updateHyphens);
window.addEventListener('resize', updateHyphens);


document.addEventListener('DOMContentLoaded', function () {
  function initPriceSync() {
    const subsRoot = document.querySelector('.sealsubs-target-element');
    const stickyBlock = document.querySelector('.sticky-price');
    if (!subsRoot || !stickyBlock) return false;

    // Key elements
    const stickyPriceSaleEl = stickyBlock.querySelector('.price-item--sale.price-item--last');
    const stickyPriceRegularEls = stickyBlock.querySelectorAll('.price-item--regular');
    const discountEl = stickyBlock.querySelector('.product-dis-price .discount');

    if (!stickyPriceSaleEl || stickyPriceRegularEls.length === 0 || !discountEl) return false;
    console.log('✅ Elements detected — initializing price sync');

    // Remember the original discount text for restore later
    const originalDiscountText = discountEl.textContent.trim();

    const productData = JSON.parse(subsRoot.dataset.product.replace(/&quot;/g, '"'));
    const basePrice = productData.variants[0].price / 100;

    const optionContainers = subsRoot.querySelectorAll('.sls-option-container');

    function formatPrice(value) {
      return `€${value.toFixed(2).replace('.', ',')}`;
    }

    // Get highest visible price (for discount calculation)
    function getLargestPrice() {
      const prices = Array.from(stickyPriceRegularEls)
        .map(el => parseFloat(el.textContent.replace(/[^\d,]/g, '').replace(',', '.')))
        .filter(v => !isNaN(v));

      const sale = parseFloat(stickyPriceSaleEl?.textContent.replace(/[^\d,]/g, '').replace(',', '.'));
      if (!isNaN(sale)) prices.push(sale);

      return prices.length ? Math.max(...prices) : basePrice;
    }

    optionContainers.forEach(container => {
      container.addEventListener('click', () => {
        const isSubscription = container.querySelector('[data-type="subscription"]');
        const largestPrice = getLargestPrice();

        if (!isSubscription) {
          // One-time purchase selected → revert to normal or original discount
          stickyPriceSaleEl.textContent = formatPrice(basePrice);

          // Restore original discount text (don’t remove it)
          discountEl.textContent = originalDiscountText;
          stickyPriceRegularEls.forEach(el => (el.textContent = formatPrice(largestPrice)));
          return;
        }

        // Subscription selected
        const select = container.querySelector('select[name="subs_interval"]');
        if (!select) return;
        const selectedPlanId = select.value;
        const variant = productData.variants[0];
        const allocation = variant.selling_plan_allocations.find(
          a => a.selling_plan_id === selectedPlanId
        );
        if (!allocation) return;

        const newPrice = allocation.price / 100;
        const discount = largestPrice - newPrice;

        stickyPriceSaleEl.textContent = formatPrice(newPrice);
        discountEl.textContent = `Du sparst ${formatPrice(discount)}`;
        stickyPriceRegularEls.forEach(el => (el.textContent = formatPrice(largestPrice)));
      });
    });

    return true;
  }

  // Try immediate init
  if (initPriceSync()) return;

  // Otherwise, observe DOM for late-loaded elements
  const observer = new MutationObserver(() => {
    if (initPriceSync()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
